import { Conversation } from '@web/conversations/types/Conversation';
import { Message } from '@web/conversations/types/Message';

import { ConversationState } from './conversationProvider.types';

type ConversationContext = {
  messages: Message[];
  selectedMessageId: number | null;
};

export const createInitialState = (
  conversation: Conversation,
  initialState: ConversationState,
  context: ConversationContext
): ConversationState => {
  const { messages, selectedMessageId } = context;

  const allIds = messages.map((m) => m.id);
  const byId = messages.reduce((acc, m) => {
    acc[m.id] = m;
    return acc;
  }, {});

  return {
    ...initialState,
    creatorId: conversation.creatorId,
    firstUnreadMessageId: conversation.firstUnreadMessageId,
    id: conversation.id,
    interlocutor: conversation.interlocutor,
    isArchived: conversation.isArchived,
    isDisabled: conversation.isDisabled,
    isPinned: conversation.isPinned,
    isPrivate: conversation.isPrivate,
    isSilenced: conversation.isSilenced,
    markedMessage: {
      id: selectedMessageId,
      isHighlighted: true,
    },
    memberIds: conversation.memberIds,
    messages: {
      allIds,
      byId,
      visibleIds: allIds,
    },
    name: conversation.name,
    newestMessageId: conversation.newestMessageId,
    restricted: conversation.restricted,
    restrictedToPersonas: conversation.restrictedToPersonas,
    quotedMessageId: null,
    selectedMessageId,
    slug: conversation.slug,
    unreadMessagesCount: conversation.unreadMessagesCount,
  };
};

export const getPrecedingMessage = (messages: ConversationState['messages'], messageId: ID) => {
  const { allIds, byId } = messages;

  const precedingMessageId = allIds.findIndex((id) => id === messageId);
  const precedingMessage = byId[allIds[precedingMessageId + 1]] ?? null;

  return precedingMessage;
};

export const getLastMessage = (messages: ConversationState['messages']) => {
  const { allIds, byId } = messages;

  const lastMessageId = allIds[0];
  const lastMessage = byId[lastMessageId];

  return lastMessage;
};
